module.exports = __webpack_public_path__ + "img/7.0_News_Harrison-award@2x.2cba94a9eefdddd06898252b1a6450fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.0_News_Harrison-award@2x.png
// module id = 801
// module chunks = 0